import React from 'react'

const ReusableDiscover = ({img}) => {
  return (
    <>
        <div class="col-lg-4">
            <div class="discover_main">
              <div class="discover_img">
                <img src={img}  alt=""/>
              </div>
              <div class="discover_text">
                <h6>Organic  Vegetables</h6>
                <ul class="icson">
                 <li><i class="fa-solid fa-star"></i></li>
                 <li><i class="fa-solid fa-star"></i></li>
                 <li><i class="fa-solid fa-star"></i></li>
                 <li><i class="fa-solid fa-star"></i></li>
                 <li><i class="fa-solid fa-star"></i></li>
                </ul>
                <p>$8.00 <samp>$10.00</samp> </p>
              </div>
              <div class="discover_overlay">
                <div class="icon"><i class="fa-regular fa-heart"></i></div>
                <div class="icon"><i class="fa-solid fa-bag-shopping"></i></div>
                <div class="icon"><i class="fa-regular fa-eye"></i></div>
              </div>
            </div>
          </div>
    </>
  )
}

export default ReusableDiscover